import { fetchApi } from '@/lib/fetcher';

/**
 * Host `fetch` for `@fanduel/rewards-hub-client` so HTTP uses the same `fetchApi`
 * pipeline as the rest of the app.
 */
export const rewardsHubRequest = (url: string, options?: RequestInit) => fetchApi(url, options);
